import exchange_currencies from "./exchange_currencies";
import invoice_statuses from "./invoice_statuses";

export default {
    exchange_currencies,
    invoice_statuses,
};
